/**
 * Its own file rather than an export from `App.tsx`.
 *
 * Several pages need it, and importing it from `App` makes every one of them a
 * circular import back into the route table — which works in ESM right up until
 * a bundler hoists something unexpectedly.
 */
export function FullPageSpinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <p className="text-sm text-ink-500" role="status">
        {label}
      </p>
    </div>
  );
}
